module.exports = __webpack_public_path__ + "../css/grid.css";


//////////////////
// WEBPACK FOOTER
// ./_dev/scss/grid.css
// module id = 2
// module chunks = 0